import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import BookItem from "./components/Books/BookItem";
import Filter from "./components/Books/Filter";
import BookForm from "./components/Books/Form";
import Navbar from "./components/Navbar";
import fetchBooks from "./redux/books/thunk/fetchBooks";

function App() {
  const dispatch = useDispatch();
  const { books } = useSelector((state) => state.books);
  console.log("🚀 ~ file: App.js:12 ~ App ~ books:", books);
  useEffect(() => {
    dispatch(fetchBooks());
  }, [dispatch]);
  return (
    <>
      <Navbar />
      <main className="py-12 2xl:px-6">
        <div className="container grid xl:grid-cols-[auto_350px] 2xl:grid-cols-[auto_400px] gap-4 2xl:gap-8">
          <div className="order-2 xl:-order-1">
            <div className="flex items-center justify-between mb-12">
              <h4 className="mt-2 text-xl font-bold">Book List</h4>
              <Filter />
            </div>
            <div className="lws-bookContainer">
              {books?.map((book) => (
                <BookItem key={book.id} book={book} />
              ))}
            </div>
          </div>
          <div>
            <BookForm />
          </div>
        </div>
      </main>
    </>
  );
}

export default App;
